import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";
import { History } from "lucide-react";

export default function WalletHistory() {
  const [tab, setTab] = useState("p2p");
  const [p2p, setP2p] = useState(null);
  const [topups, setTopups] = useState(null);
  const [withdrawals, setWithdrawals] = useState(null);
  useEffect(() => {
    api("/wallet/p2p/history").then(setP2p).catch(() => setP2p([]));
    api("/wallet/my-topups").then(setTopups).catch(() => setTopups([]));
    api("/withdrawals/mine").then(setWithdrawals).catch(() => setWithdrawals([]));
  }, []);
  if (!p2p || !topups || !withdrawals) return <Loader />;
  const lists = { p2p, topups, withdrawals };
  const list = lists[tab] || [];
  const labels = [["p2p", "تحويلات"], ["topups", "شحن"], ["withdrawals", "سحوبات"]];
  return (
    <div className="animate-fade-in-up max-w-2xl mx-auto">
      <PageHeader title="سجل المحفظة" backTo="/wallet" />
      <div className="flex gap-2 mb-4">
        {labels.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`px-5 py-2.5 rounded-xl font-black text-sm ${tab === k ? "bg-[#FF3D5A] text-white" : "bg-white border border-[#E8EAF2]"}`}>{l} ({lists[k].length})</button>)}
      </div>
      {list.length === 0 ? <EmptyState icon={History} title="لا توجد عمليات" /> : (
        <div className="space-y-2">
          {list.map((x, i) => (
            <div key={x.id || x.topup_id || x.withdrawal_id || i} className="flex items-center justify-between p-4 bg-white rounded-2xl border border-[#E8EAF2]">
              <div>
                <p className="font-bold text-[#161629]">{tab === "p2p" ? (x.to_name || x.from_name || "تحويل") : tab === "topups" ? "شحن محفظة" : "سحب رصيد"}</p>
                <p className="text-xs text-[#6B7280]">{x.created_at ? new Date(x.created_at).toLocaleString("ar") : ""}{x.status ? ` • ${x.status}` : ""}</p>
              </div>
              <span className="font-black text-[#FF3D5A]">{Number(x.amount || 0).toFixed(2)} د.ل</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
